/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from "axios";
import { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";
import ViewTeam from "../ViewTeam";
import pdficon from "../../../assests/word (2).png";
import wordicon from "../../../assests/word (1).png";
import arrow from "../../../assests/arrow_17004509.png";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Form, Input, Typography, Button, Divider, Select } from "antd";
import { FilePdfOutlined, FileWordOutlined } from "@ant-design/icons";
import CircularPercentage from "../../../components/CircularPercentage";
import { Radio, Checkbox, Space, Card } from "antd";

const { TextArea } = Input;
const { Title, Text } = Typography



export default function HodOneEdit({ data }) {
    const { authData, backUrl } = useContext(AuthContext);
    const [mrfDetails, setMrfDetails] = useState(null);
    const [error, setError] = useState("");
    const [showData, setShowData] = useState(true);
    const [departments, setDepartments] = useState([]);
    const [designation, setDesignations] = useState([]);
    const [organizationNames, setOrganizationNames] = useState([]);
    const [workLocation, setWorkLocation] = useState([]);
    const [errors, setErrors] = useState({});

    const [taken, setTaken] = useState(0)


    const fetchData = async () => {
        try {
            const res = await axios.get(
                `${backUrl}/api/emp/manpowerrequisitions/${data}/`,
                {
                    headers: {
                        'Authorization': `Bearer ${authData.access}`,
                        'Content-Type': 'application/json',
                    },
                }
            );
            setMrfDetails(res.data);
        } catch (err) {
            console.error("Fetch error:", err);
            setError("Failed to fetch MRF data.");
        }
    };

    const fetchOrganizations = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/organisations/`, {
                headers: {
                    'Authorization': `Bearer ${authData.access}`,
                    'Content-Type': 'application/json',
                },
            });
            setOrganizationNames(res.data.results);
        } catch (err) {
            console.error("Failed to fetch organizations:", err);
        }
    };

    const fetchWorkLocation = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/worklocation/`);
            setWorkLocation(res.data.results);
            console.log("workLocation", res.data.results)
        } catch (err) {
            console.error("Error fetching designations", err);
        }
    }

    const fetchDepartments = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/departments/`);
            setDepartments(res.data.results);
        } catch (err) {
            console.error("Failed to fetch departments:", err);
        }
    };

    const fetchDesignations = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/designations/`);
            setDesignations(res.data.results);
        } catch (err) {
            console.error("Failed to fetch designations:", err);
        }
    };

    const validateForm = () => {

        if (mrfDetails.manager_approved === false) {
            const requiredFields = [
                'manager_remarks'

            ];

            const newErrors = {};

            requiredFields.forEach(field => {
                if (!mrfDetails[field]) {
                    newErrors[field] = "This field is required.";
                }
            });

            setErrors(newErrors);
            return Object.keys(newErrors).length === 0;
        }
        else {
            const requiredFields = [
                'mrf_salary_from', 'mrf_salary_to', 'manager_remarks'

            ];

            const newErrors = {};

            requiredFields.forEach(field => {
                if (!mrfDetails[field]) {
                    newErrors[field] = "This field is required.";
                }
            });

            setErrors(newErrors);
            return Object.keys(newErrors).length === 0;
        }


    };

    useEffect(() => {

        fetchData();
        fetchDepartments();
        fetchDesignations();
        fetchOrganizations();
        fetchWorkLocation();

    }, []);

    // useEffect(() => {
    //     if (data && authData?.access) {
    //         const interval = setInterval(() => {
    //             fetchData();
    //         }, 30000);

    //         return () => clearInterval(interval);
    //     }
    // }, [authData]);

    const getOrganizationName = (id) => organizationNames.find(o => o.id === id)?.name || id || "-";
    const getDepartmentName = (id) => departments.find(dep => dep.id === id)?.name || id || "-";
    const getDesignationTitle = (id) => designation.find(des => des.id === id)?.name || id || "-";

    const handleClick = () => setShowData(false);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const newValue = type === "checkbox" ? checked : value;
        setMrfDetails({ ...mrfDetails, [name]: newValue });
    };

    const [loader, setLoader] = useState(false);

    const handleSubmit = async () => {
        try {
            setLoader(true)
            if (!validateForm()) {
                toast.error("Please fill all required fields.");
                return;
            }

            const payload = {
                ...mrfDetails,
                manager_approved: mrfDetails.manager_approved ? 1 : 0,
            };
            const res = await axios.put(
                `${backUrl}/api/emp/manpowerrequisitions/${data}/manager_approve/  `,
                payload,
                {
                    headers: {
                        'Authorization': `Bearer ${authData.access}`,
                        'Content-Type': 'application/json',
                    },
                }
            );

            toast.success(res.data.message)


            setMrfDetails(res.data);
            setShowData(false)
        } catch (err) {
            console.error("Update error:", err);

            let errorMessage = "Something went wrong";

            if (err.response?.data) {
                if (typeof err.response.data === "string") {
                    errorMessage = err.response.data;
                }
                else if (err.response.data.message) {
                    errorMessage = err.response.data.message;
                }
                else if (err.response.data.detail) {
                    errorMessage = err.response.data.detail;
                }
                else {
                    const firstKey = Object.keys(err.response.data)[0];
                    errorMessage = Array.isArray(err.response.data[firstKey])
                        ? err.response.data[firstKey][0]
                        : err.response.data[firstKey];
                }
            } else if (err.message) {
                errorMessage = err.message;
            }

            toast.error(errorMessage);
            setError(errorMessage);
        }
        finally {
            setLoader(false)
        }
    };

    const fetchTaken = async () => {
        const res = await axios.get(`${backUrl}/api/emp/candidates/?offerletter_status=ACCEPTED&requisition_id=${mrfDetails.id}`,
            {
                headers: {
                    'Authorization': `Bearer ${authData.access}`,
                    'Content-Type': 'application/json',
                },
            });
        setTaken(res.data.count)
        console.log(mrfDetails.id)
    }


    useEffect(() => {
        if (mrfDetails?.id) {
            fetchTaken();
        }
    }, [mrfDetails]);

    return (
        <div className="view-container">
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
            {showData ? (
                <>
                    {/* {error} */}
                    {!mrfDetails ? (
                        <p>Loading MRF Details...</p>
                    ) : (
                        <>
                            <button className="bread" onClick={handleClick}>
                                ← Back to List
                            </button>

                            <div className="d-flex justify-content-center align-items-center">
                                <section>
                                    <center><h5>Manpower Requisition Form</h5></center>
                                    {/* <center>
                                        <h6 id={mrfDetails.mrf_status === 'Open' ? "status-indicator-green" : "status-indicator-gray"}>CURRENT STATUS -{" "}
                                            {mrfDetails.mrf_status === "Close" ? "Closed" : mrfDetails.mrf_status}</h6>
                                    </center> */}
                                </section>
                                {
                                    mrfDetails.status === "Sanctioned" && (
                                        <section className="mx-5">
                                            {/* <Text level={4}>Completion status</Text> */}
                                            <CircularPercentage vacancies={mrfDetails.no_of_vacancies} taken={taken} />

                                        </section>
                                    )
                                }
                            </div>
                            <div className="form container">
                                <div>
                                    <label>Organization</label>
                                    <input type="text" name="organisation" value={getOrganizationName(mrfDetails.organisation)} onChange={handleChange} readOnly />
                                </div>
                                <div>
                                    <label>Department</label>
                                    <input type="text" name="department" value={getDepartmentName(mrfDetails.department)} onChange={handleChange} readOnly />
                                </div>
                                <div>
                                    <label>Designation</label>
                                    <input type="text" name="designation" value={getDesignationTitle(mrfDetails.designation)} onChange={handleChange} readOnly />
                                </div>
                                <div>
                                    <label>Site/Location</label>
                                    <input type="text" name="site_location" value={mrfDetails.site_location || ""} onChange={handleChange} readOnly />
                                </div>
                                <div>
                                    <label>Required By</label>
                                    <input type="text" name="required_by" value={mrfDetails.required_by || ""} onChange={handleChange} readOnly />
                                </div>
                                <div>
                                    <label>No. of Vacancies</label>
                                    <input type="text" name="no_of_vacancies" value={mrfDetails.no_of_vacancies || ""} onChange={handleChange} readOnly />
                                </div>
                            </div>

                            <center>
                                <div id="center-area">
                                    <div id="requisition-type">
                                        <Form.Item label="Requisition Type">
                                            <Input value={mrfDetails.requisition_type || ""} readOnly />
                                        </Form.Item>
                                    </div>
                                    {
                                        mrfDetails.hr_approved && (
                                            <>

                                                <div id="download-area">
                                                    <>
                                                        <Typography.Text>
                                                            Download
                                                        </Typography.Text>
                                                        <Button
                                                            type="link"
                                                            icon={<FilePdfOutlined style={{ fontSize: '30px' }} />}
                                                            onClick={async (e) => {
                                                                e.preventDefault();
                                                                try {
                                                                    const response = await axios.get(
                                                                        `${backUrl}/api/emp/mrf/${mrfDetails.mrf_number}/download/?type=1`,
                                                                        { responseType: 'blob' }
                                                                    );

                                                                    const disposition = response.headers['content-disposition'];
                                                                    let filename = 'download.pdf';
                                                                    if (disposition && disposition.includes('filename=')) {
                                                                        filename = disposition
                                                                            .split('filename=')[1]
                                                                            .replace(/['"]/g, '')
                                                                            .trim();
                                                                    }

                                                                    const url = window.URL.createObjectURL(new Blob([response.data]));
                                                                    const link = document.createElement('a');
                                                                    link.href = url;
                                                                    link.setAttribute('download', filename);
                                                                    document.body.appendChild(link);
                                                                    link.click();
                                                                    document.body.removeChild(link);
                                                                    window.URL.revokeObjectURL(url);
                                                                } catch (error) {
                                                                    console.error('PDF download failed', error);
                                                                }
                                                            }}
                                                        />

                                                        <Button
                                                            type="link"
                                                            icon={<FileWordOutlined style={{ fontSize: '30px' }} />}
                                                            onClick={async (e) => {
                                                                e.preventDefault();
                                                                try {
                                                                    const response = await axios.get(
                                                                        `${backUrl}/api/emp/mrf/${mrfDetails.mrf_number}/download/?type=2`,
                                                                        { responseType: 'blob' }
                                                                    );

                                                                    const disposition = response.headers['content-disposition'];
                                                                    let filename = 'download.docx';
                                                                    if (disposition && disposition.includes('filename=')) {
                                                                        filename = disposition
                                                                            .split('filename=')[1]
                                                                            .replace(/['"]/g, '')
                                                                            .trim();
                                                                    }

                                                                    const url = window.URL.createObjectURL(new Blob([response.data]));
                                                                    const link = document.createElement('a');
                                                                    link.href = url;
                                                                    link.setAttribute('download', filename);
                                                                    document.body.appendChild(link);
                                                                    link.click();
                                                                    document.body.removeChild(link);
                                                                    window.URL.revokeObjectURL(url);
                                                                } catch (error) {
                                                                    console.error('Word download failed', error);
                                                                }
                                                            }}
                                                        />
                                                    </>
                                                </div>

                                            </>
                                        )
                                    }

                                </div>
                            </center>

                            <hr />
                            <div className="form-2">
                                <div className="deployment-area">
                                    <h3>Deployment</h3>
                                    <label>Place Of Work </label>
                                    <input
                                        type="text"
                                        name="place_of_work"

                                        value={
                                            Array.isArray(mrfDetails.place_of_work)
                                                ? mrfDetails.place_of_work.join(", ")
                                                : ""
                                        }
                                        readOnly
                                    />
                                    {/* <input
                                        type="text"
                                        value={
                                            Array.isArray(selectedReq.place_of_work)
                                                ? selectedReq.place_of_work.join(", ")
                                                : ""
                                            }
                                            readOnly
                                        /> */}
                                    {/* <label>Reporting To</label>
                                    <input type="text" name="reporting_to" value={mrfDetails.reporting_to || ""} onChange={handleChange} /> */}
                                    <label>Job Description</label>
                                    <textarea name="job_description" value={mrfDetails.job_description || ""} onChange={handleChange} readOnly />

                                    <a
                                        className="jd-anchor"
                                        href={mrfDetails.job_description_attachment}
                                        style={{
                                            background: 'transparent',
                                            color: 'black',
                                            textDecoration: 'none'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.color = 'black';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.color = 'black';
                                        }}
                                    >
                                        JD Attachment : View File
                                    </a>


                                    <h5 className={mrfDetails.manager_approved === false && "d-none"}>Salary Range</h5>
                                    <label className={mrfDetails.manager_approved === false && "d-none"}>From</label>
                                    <input className={mrfDetails.manager_approved === false && "d-none"} type="number" name="mrf_salary_from" value={mrfDetails.mrf_salary_from || ""} onChange={handleChange} />
                                    {errors.mrf_salary_from && <p style={{ color: 'red', fontSize: '12px' }}>{errors.mrf_salary_from}</p>}
                                    <label className={mrfDetails.manager_approved === false && "d-none"}>To</label>
                                    <input className={mrfDetails.manager_approved === false && "d-none"} type="number" name="mrf_salary_to" value={mrfDetails.mrf_salary_to || ""} onChange={handleChange} />
                                    {errors.mrf_salary_to && <p style={{ color: 'red', fontSize: '12px' }}>{errors.mrf_salary_to}</p>}


                                </div>

                                <div className="requirement-profile">
                                    <h3>Requirement Profile</h3>
                                    <label>Qualification</label>
                                    <input type="text" name="qualification" value={mrfDetails.qualification || ""} onChange={handleChange} readOnly />
                                    <label>Experience</label>
                                    <input type="text" name="experience" value={mrfDetails.experience || ""} onChange={handleChange} readOnly />
                                    <label>Skill Sets</label>
                                    <textarea name="skill_sets" value={mrfDetails.skill_sets || ""} onChange={handleChange} />
                                    <label>Any Other Requirements</label>
                                    <textarea name="other_requirements" value={mrfDetails.other_requirements || ""} onChange={handleChange} readOnly />
                                    <label>Justification</label>
                                    <textarea name="justification" value={mrfDetails.justification || ""} onChange={handleChange} readOnly />
                                </div>
                            </div>

                            {mrfDetails.requisition_type === 'Replacement' && (
                                <>
                                    <h3>If Replacement</h3>
                                    <div className="replacement-form">
                                        <label>Name of the Leaving Employee</label>
                                        <input type="text" name="name_of_leaving_employee" value={mrfDetails.name_of_leaving_employee || ""} onChange={handleChange} readOnly />
                                        <label>Date of Leaving</label>
                                        <input type="text" name="date_of_leaving" value={mrfDetails.date_of_leaving || ""} onChange={handleChange} readOnly />
                                        <label>Reason for Leaving</label>
                                        <textarea name="reason_for_leaving" value={mrfDetails.reason_for_leaving || ""} onChange={handleChange} readOnly />
                                        <label>Present Strength in the Category</label>
                                        <input type="text" name="present_dept_strength" value={mrfDetails.present_dept_strength || ""} onChange={handleChange} readOnly />
                                        <label>Strength of the Function</label>
                                        <input type="text" name="strength_of_function" value={mrfDetails.strength_of_function || ""} onChange={handleChange} readOnly />
                                        <label>Remarks</label>
                                        <textarea name="replacement_remarks" value={mrfDetails.replacement_remarks || ""} onChange={handleChange} readOnly />
                                    </div>
                                </>
                            )}

                            <div>
                                <Card style={{ maxHeight: 400, maxWidth: 1200, margin: "20px auto", padding: 24, borderRadius: 12, boxShadow: "0 2px 8px rgba(0,0,0,0.1)", backgroundColor: '#fafcff', borderRadius: '10px', border: '1px solid #c2d3e0' }}>
                                    <center>
                                        <Title level={4} style={{ textAlign: "center", marginBottom: 24 }}>
                                            APPROVAL
                                        </Title>

                                        <Space direction="vertical" size="middle" style={{ maxWidth: 1000 }}>
                                            <Radio.Group
                                                onChange={(e) => setMrfDetails({ ...mrfDetails, manager_approved: e.target.value })}
                                                value={
                                                    mrfDetails.manager_approved === 1
                                                        ? true
                                                        : mrfDetails.manager_approved === 0
                                                            ? false
                                                            : mrfDetails.manager_approved
                                                }
                                                style={{ display: "flex", justifyContent: "center", gap: 20 }}
                                            >
                                                <Radio value={true}>Approved</Radio>
                                                <Radio value={false}>Rejected</Radio>
                                            </Radio.Group>
                                            {errors.manager_approved && <Text type="danger">{errors.manager_approved}</Text>}

                                            {/* <Title level={5} style={{ textAlign: "center", marginTop: 20 }}>
                                                Remarks
                                            </Title> */}
                                            <TextArea
                                                name="manager_remarks"
                                                value={mrfDetails.manager_remarks || ""}
                                                onChange={handleChange}
                                                placeholder="Remarks"
                                                rows={4}
                                                style={{ width: "500px" }}
                                            />
                                            {errors.manager_remarks && <Text type="danger">{errors.manager_remarks}</Text>}

                                            <div style={{ textAlign: "center", marginTop: 0 }}>
                                                <Button
                                                    type="primary"
                                                    onClick={handleSubmit}
                                                    style={{ backgroundColor: "#0e497b", borderColor: "#0e497b" }}
                                                    loading={loader}
                                                    disabled={loader}
                                                >
                                                    Submit
                                                </Button>
                                            </div>
                                        </Space>
                                    </center>

                                </Card>

                                <Divider />

                                {
                                    mrfDetails.status === "Sanctioned" && (
                                        <center>
                                            <div className="p-4" id="approval-hr" style={{ textAlign: "center" }}>
                                                <Title level={4}>HR Approval Status</Title>
                                                <br />

                                                <div className="approval-area">
                                                    <Space direction="vertical" size="middle" style={{ width: "100%" }}>
                                                        {/* Radio Buttons */}
                                                        <Radio.Group
                                                            name="hr_approved"
                                                            value={mrfDetails.hr_approved}
                                                        >
                                                            <Radio value={true}>Sanctioned</Radio>
                                                            <Radio value={false}>Rejected</Radio>
                                                        </Radio.Group>

                                                        {/* Remarks */}
                                                        <Input.TextArea
                                                            rows={4}
                                                            placeholder="Enter remarks"
                                                            name="hr_remarks"
                                                            value={mrfDetails.hr_remarks}
                                                            style={{ maxWidth: '500px' }}
                                                        />
                                                    </Space>
                                                </div>
                                            </div>
                                        </center>
                                    )
                                }

                                {<div className="approval-area">
                                    {(mrfDetails.hr_approved === true || mrfDetails.hr_approved === false) ? (
                                        // <Card
                                        //     bordered={true}
                                        //     style={{
                                        //         maxWidth: "1000px",
                                        //         margin: "0 auto",
                                        //         borderRadius: "12px",
                                        //         boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                        //         background: "#f9f9ff",
                                        //     }}
                                        // >
                                        //     <Title level={3} style={{ textAlign: "center", marginBottom: "20px" }}>
                                        //         HR Approval
                                        //     </Title>

                                        //     <Form layout="vertical">
                                        //         <div className="d-flex">
                                        //         <Form.Item>
                                        //             <Checkbox checked={mrfDetails.hr_approved === true} >
                                        //                 Sanctioned
                                        //             </Checkbox>
                                        //         </Form.Item>
                                        //         <Form.Item>
                                        //             <Checkbox checked={mrfDetails.hr_approved === false} >
                                        //                 Rejected
                                        //             </Checkbox>
                                        //         </Form.Item>
                                        //         </div>


                                        //         <Form.Item label="Approved By">
                                        //             <Input
                                        //                 value={mrfDetails.hr_approved_by_display}
                                        //                 readOnly
                                        //             />
                                        //         </Form.Item>

                                        //         <Form.Item label="HR Remarks">
                                        //             <TextArea
                                        //                 value={mrfDetails.hr_remarks}
                                        //                 readOnly
                                        //                 placeholder="Remarks"
                                        //                 rows={3}
                                        //             />
                                        //         </Form.Item>
                                        //     </Form>
                                        // </Card>
                                        <>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                    <br />
                                    {
                                        (mrfDetails.mrf_allocated_to !== '0' || mrfDetails.mrf_allocated_to !== 0) && (
                                            <Select
                                                placeholder="Select HR"
                                                style={{ width: 200 }}
                                                allowClear={false}
                                                value={mrfDetails.mrf_allocated_to}
                                                disabled
                                            >
                                                <Select.Option value={mrfDetails.mrf_allocated_to}>
                                                    {mrfDetails.mrf_allocated_to_display}
                                                </Select.Option>
                                            </Select>
                                        )
                                    }
                                </div>}


                            </div>

                        </>
                    )}
                </>
            ) : (
                <ViewTeam />
            )
            }
        </div >
    );
}